export enum ActionName {
  Redaction = 'Redaction',
  StudyStartup = 'Study Startup',
  CollaborationReviewer = 'Authoring Reviewer',
  CollaborationAdministrator = 'Authoring Administrator',
  PageManipulations = 'Page Manipulations',
  ESignature = 'eSignature',
  UserLookup = 'User Lookup',
  OnlineEdit = 'Edit Document Online',
  Communication = 'Communications',
  IndexModification = 'Modify Index',
  PublishToEtmf = 'Publish to eTMF',
  EventManager = 'Event Manager',
  AssignTasks = 'Assign Tasks',
  DocumentManager = 'Document Manager',
  CraReconciliation = 'CRA Reconciliation',
  EnrollForGlCourses = 'Enroll for GL Courses',
  CRA = 'CRA',
}
